// import Vue from 'vue'

import { pad, formatNumber, formatNumberWithRounding, formatNumberWithRoundUp, formatPercentage, formatCurrency } from '@/utils/NumberFunctions'
import {
  formatDateLocale,
  formatWeekDayDateLocale,
  formatTimeLocale,
  formatDateTimeLocale,
  ensureUTCFormat,
  formatDateUtc,
  formatDateLong,
  DATE_FORMAT,
  firstDayOfMonth,
  lastDayOfMonth,
  getTimezoneOffset,
  getIanaTimezone,
  formatDateTimezone,
  getSiteTimezoneOffset,
  fromISOWithCurrentTime,
  formatISOToString,
  fromISOToJsDate,
  formatISOToLuxon,
  fromJsDateAdjustedToISO,
  fromJsDateToISO,
  customFormatDateLocale,
  isIsoDate
} from '@/utils/DateFunctions'
import { getCurrencySymbol } from '@/components/currency'
import {
  formatPascalToDescription,
  formatABN,
  formatPartType,
  formatQdeStatus,
  formatAssetType,
  formatPOItemType,
  replaceBr,
  formatInvoiceType,
  formatBatchStatus,
  formatOrmBatchStatus,
  camelCaseToDescription,
  formatJobStage,
  formatPartCondition
} from '@/utils/StringFunctions'

const filters = {
  pad,
  formatNumber,
  formatNumberWithRounding,
  formatNumberWithRoundUp,
  formatPercentage,
  formatCurrency,
  formatDateLocale,
  formatWeekDayDateLocale,
  formatTimeLocale,
  formatDateTimeLocale,
  ensureUTCFormat,
  formatDateUtc,
  formatDateLong,
  getCurrencySymbol,
  DATE_FORMAT,
  firstDayOfMonth,
  lastDayOfMonth,
  getTimezoneOffset,
  getIanaTimezone,
  formatDateTimezone,
  getSiteTimezoneOffset,
  fromISOWithCurrentTime,
  formatPascalToDescription,
  formatISOToString,
  fromISOToJsDate,
  formatISOToLuxon,
  fromJsDateAdjustedToISO,
  fromJsDateToISO,
  customFormatDateLocale,
  formatABN,
  formatPartType,
  formatQdeStatus,
  formatAssetType,
  formatPOItemType,
  replaceBr,
  formatInvoiceType,
  formatBatchStatus,
  formatOrmBatchStatus,
  camelCaseToDescription,
  formatJobStage,
  formatPartCondition,
  isIsoDate
}

export default filters
